import {
  ChangeDetectionStrategy,
  Component,
  input,
  Input,
  InputSignal,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { MeterGroupModule } from 'primeng/metergroup';
import { ProgressBarModule } from 'primeng/progressbar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ColorUtils } from '../../utils/ColorUtils';
import { TimeMetric } from '../../../../types';
import { Nullable } from 'primeng/ts-helpers';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-time-metrics',
  standalone: true,
  imports: [
    ProgressBarModule,
    MeterGroupModule,
    ButtonModule,
    SplitButtonModule,
    SkeletonModule,
  ],
  templateUrl: './app-time-metrics.component.html',
  styleUrl: './app-time-metrics.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeMetricsComponent {
  public ColorUtils = ColorUtils;

  @Input() public title: Nullable<string>;
  @Input() public loading: Nullable<boolean>;
  @Input() public helpText: Nullable<string>;

  public metric: InputSignal<TimeMetric> = input.required<TimeMetric>();
}
